import './css/Laboratorio.css';
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cuestionarios from "../actividades/Cuestionarios";
import Actividades from "../actividades/Actividades";

function Laboratorio({acceder, rol}) {
    const [ver, setVer] = useState('');
    const { idMC } = useParams();
    const navigate = useNavigate();
    const idCG =localStorage.getItem('loggeduserCursoGrupo');
    const loggeduserCurso = localStorage.getItem('loggeduserCurso');
    
    
    useEffect(() => {
        if(acceder){
            if((rol===null)){
                navigate("/");
            }
            console.log('idMC: ', idMC);
            console.log('idCG: ', idCG);
            console.log('loggeduserCurso: ', loggeduserCurso);
        }
    }, []);
    return (    
        <div className="container-principal mb-4">
            <h3>Laboratorio <i className='fa-solid fa-flask text-success'></i></h3>
            <div className='d-flex-1'>
                <button type="button" className="btn-laboratorio m-1" onClick={()=>setVer('actividades')}>Actividades</button>
                <button type="button" className="btn-laboratorio m-1" onClick={()=>setVer('cuestionario')}>Cuestionarios</button>
               {/* 
                <button type="button" className="btn-laboratorio m-1" onClick={()=>setVer('rubrica')}>Rubricas de evaluación</button>
               */} 
                
            </div>
            {ver==='actividades' && <Actividades idMC={idMC} rol={rol} />}
            {ver==='cuestionario' && <Cuestionarios idMC={idMC} rol={rol}  />}
    
            
        </div>
     );
}

export default Laboratorio;